import {customAxiosBE} from "../config";
import axios from "axios";
import {parsePaginationParams} from "../../utils/other";

// CENOVNICI
export async function getAllRateCardsAPI(payload) {
    const parsedParams = parsePaginationParams(payload)
    return customAxiosBE.post(`/rateCard/search?${parsedParams}`, {})
}

export async function getAllRateCardsWithOperatorAPI(payload) {
    const parsedParams = parsePaginationParams(payload)
    return customAxiosBE.get(`/rateCard/withOperator?${parsedParams}`)
}

export async function getRateCardAPI(id) {
    return customAxiosBE.get(`/rateCard/${id}`)
}

export async function getAllLinkedRateCardsAPI() {
    return customAxiosBE.get(`/rateCard/allLinkedRateCards`)
}

export async function findByDepStationIDLineIDAndRateID(payload) {
    return customAxiosBE.post(`/rateCard/findBy`, payload)
}

export async function updatePricesFromItinerer(payload) {
    return customAxiosBE.post(`/rateCard/updatePrices`, payload)
}


export async function findAllRateCardsByTripId(tripId, isCalem = false) {
    return customAxiosBE.get(`/rateCard/rateCardsByTripId/${tripId}`, {
        params: {
            isCalem
        }
    });
}


export async function insertRateCardsAPI(payload) {
    return customAxiosBE.post(`/rateCard`, payload)
}

export async function updateRateCardAPI(payload) {
    return customAxiosBE.put(`/rateCard`, payload)
}

export async function deleteRateCardsAPI(id) {
    return customAxiosBE.delete(`/rateCard/${id}`)
}

export const searchRateCardAPI = async (data, cancelToken) => {
    let response
    const {name, validFrom, validTo, operatorId, operatorName,onlyActive} = data
    const parsedParams = parsePaginationParams(data)
    await customAxiosBE
        .post(`/rateCard/search?${parsedParams}`, {
            name: name,
            onlyActive: onlyActive,
            operatorName: operatorName,
            validFrom: validFrom,
            validTo: validTo,
            operatorId: operatorId
        }, {
            cancelToken
        })
        .then((r) => {
            response = r.data
        })
        .catch(error => {
            if (axios.isCancel(error)) {
                console.error('Request canceled', error.message);
            } else {
                // handle error response
            }
        });
    return response
}

export const searchRateCardBySubOperatorsAPI = async (data, cancelToken) => {
    let response
    const {name, validFrom, validTo, operatorId, operatorName} = data
    const parsedParams = parsePaginationParams(data)
    await customAxiosBE
        .post(`/rateCard/searchBySubOperators?${parsedParams}`, {
            name: name,
            operatorName: operatorName,
            validFrom: validFrom,
            validTo: validTo,
            operatorId: operatorId
        }, {
            cancelToken
        })
        .then((r) => {
            response = r.data
        })
        .catch(error => {
            if (axios.isCancel(error)) {
                console.error('Request canceled', error.message);
            } else {
                // handle error response
            }
        });
    return response
}

export const searchRateCardByOperatorAPI = async (data, cancelToken) => {
    let response
    const {name, validFrom, validTo, operatorName, operatorId, onlyMainOperator, onlyActive} = data
    const parsedParams = parsePaginationParams(data)
    await customAxiosBE
        .post(`/rateCard/searchByOperator?${parsedParams}`, {
            name: name,
            onlyActive: onlyActive,
            validFrom: validFrom,
            validTo: validTo,
            operatorName: operatorName,
            operatorId: operatorId,
            onlyMainOperator: onlyMainOperator ? onlyMainOperator : false
        }, {
            cancelToken
        })
        .then((r) => {
            response = r.data
        })
        .catch(error => {
            if (axios.isCancel(error)) {
                console.error('Request canceled', error.message);
            } else {
                // handle error response
            }
        });
    return response
}

